<template>
  <v-expansion-panels class="code">
    <v-expansion-panel>
      <v-expansion-panel-header>{{ title }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card>
          <v-card-text>
            <template v-if="code">
              <pre><code class="code">{{ bodyCopy }}</code></pre>
            </template>
            <template v-else>{{ bodyCopy }}</template>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'ExpansionPanels',
  props: {
    title: {
      type: String,
      default: 'Click to see details',
    },
    bodyCopy: {
      type: [String, Object],
      default: '',
    },
    code: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.code-panel {
  .v-card__text {
    padding: 0;
  }
}

.code {
  display: block;
  padding: 0 5px;
}
</style>
